export default "__VITE_ASSET__Dt_jOScr__"